import React from 'react';

import MergeFulfillments from '@components/shared/fulfillments/MergeFulfillments';
import MerchantSelect from '@components/operator/MerchantSelect';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import PageHeader from '@shared/PageHeader';

import { fulfillmentService } from '@services/operator/fulfillmentService';

function MergeContent() {
  const { merchantId } = useOperatorData();

  return (
    <div>
      <PageHeader items={['fulfillments', 'fulfillments.merge']} />
      <MergeFulfillments
        fulfillmentService={fulfillmentService}
        role="operator"
        merchantId={merchantId}
      />
    </div>
  );
}

export default function OperatorFulfillmentMerge() {
  return (
    <MerchantSelect>
      <MergeContent />
    </MerchantSelect>
  );
}
